module.exports = __webpack_public_path__ + "img/jiuzhou-driver-android.e6c5b722.png";